import PageUnauthorized from './PageUnauthorized';

export default PageUnauthorized;
